module.exports = __webpack_public_path__ + "static/media/115.36dd977a.png";